// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("/Users/josemoreira/git/vestedin/innovation-labs-landing-page/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-home-js": () => import("/Users/josemoreira/git/vestedin/innovation-labs-landing-page/src/pages/home.js" /* webpackChunkName: "component---src-pages-home-js" */),
  "component---src-pages-index-js": () => import("/Users/josemoreira/git/vestedin/innovation-labs-landing-page/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-subscribe-js": () => import("/Users/josemoreira/git/vestedin/innovation-labs-landing-page/src/pages/subscribe.js" /* webpackChunkName: "component---src-pages-subscribe-js" */)
}

exports.data = () => import("/Users/josemoreira/git/vestedin/innovation-labs-landing-page/.cache/data.json")

